import React, { useContext } from 'react'

import { useRequest } from '../../hooks/request'
import { me } from '../../requests/me'
import { UserContext } from '../../data/UserContext'
import { Trad } from '../common/Trad'
import { disconnect } from '../../utils/disconnect'
import { getToken } from '../../utils/sessionStorage'
import { jwtDecode } from "jwt-decode";

export const UserWaiter = ({ children }) => {
  const { user, setUser } = useContext(UserContext)
  const userRequest = useRequest({
    request: me,
    start: true,
    handler: (p) => p.then((data) => {
      if (!data) {
        disconnect()
      } else {
        const token = getToken();
        const decodedHeader = jwtDecode(token);
        data.role = decodedHeader.role;
        setUser(data)
      }
    }),
  })
  if (userRequest.state.error) {
    return <Trad id="errorRetry" />
  }
  if (user) {
    return children
  }

  return 'loading'
}
